//@ts-nocheck
// JobContext.tsx
import React, { createContext, useContext, useState, useEffect } from "react";
import { fetchDocument } from "../../features/job/jobSlices";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";

const JobContext = createContext(null);

export const JobProvider = ({ children }: any) => {
  const [jobStatus, setJobStatus] = useState(null);
  const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (jobId && baseId) {
      const fetchJob = async () => {
        const storedJob = localStorage.getItem("jobPostDetailsData");
        if (storedJob) {
          setJobStatus(JSON.parse(storedJob));
        } else {
          try {
            const response = await dispatch(
              fetchDocument({ baseId, id: jobId }),
            );
            setJobStatus(response?.payload.data);
            localStorage.setItem(
              "jobPostDetailsData",
              JSON.stringify(response?.payload.data),
            );
          } catch (error) {
            console.error("Error fetching job details:", error);
          }
        }
      };
      fetchJob();
    }
  }, [dispatch, jobId, baseId]);

  return (
    <JobContext.Provider value={{ jobStatus, setJobStatus }}>
      {children}
    </JobContext.Provider>
  );
};

export const useJob = () => useContext(JobContext);
